module.exports = __webpack_public_path__ + "img/love-bn-02.1aceb375.jpg";